export const TAGS = [
  'サイクルラック有',
  '地球ロック可',
  '空気入/工具貸出',
  'テラス席',
  '充電可',
  'Wi-Fi有',
  '給水可',
  'トイレ',
  '穴場',
  'SNS映え',
] as const;

export type SpotTag = (typeof TAGS)[number];
